export default {
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  }
};
